import { useForm } from "@mantine/form";
import { useState } from "react";
import { validateRequired } from "../../utils/validations";
import { Button, Loader, Select, Textarea, TextInput } from "@mantine/core";
import CustomDatePicker from "../common/Inputs/CustomDatePicker";
import dayjs from "dayjs";
import { createWorkPermit } from "../../api/workPermitApi";
import { useParams } from "react-router";
import { updateNotification } from "@mantine/notifications";

const WorkPermitCreateModal = ({ closeModal, reFetchData }: any) => {
  const { id } = useParams();

  const [isLoading, setIsLoading] = useState(false);
  const form = useForm({
    initialValues: {
      start: undefined,
      end: undefined,
      type: "",
      note: "",
    },
    validate: {
      start: validateRequired,
      end: validateRequired,
      type: validateRequired,
    },
  });

  const handleSubmit = async (values: any) => {
    const payload = {
      employeeId: id,
      start: dayjs(values.start).toDate().toISOString(),
      end: dayjs(values.end).toDate().toISOString(),
      type: values.type,
      note: values.note,
    };

    setIsLoading(true);
    try {
      const { data }: any = await createWorkPermit({
        ...payload,
      });

      updateNotification(data?.success);
    } catch (error) {
      console.error("Error:", error);
    } finally {
      reFetchData();
      setIsLoading(false);
      closeModal();
    }
  };

  return (
    <form
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "15px",
      }}
      onSubmit={form.onSubmit(handleSubmit)}
    >
      <CustomDatePicker
        label="İzin Başlangıç Tarihi"
        placeholder="Tarih Seçiniz."
        w={"100%"}
        size="md"
        {...form.getInputProps("start")}
      />
      <CustomDatePicker
        label="İzin Bitiş Tarihi"
        placeholder="Tarih Seçiniz."
        minDate={form.values.start}
        w={"100%"}
        size="md"
        {...form.getInputProps("end")}
      />
      <Select
        label="İzin Tipi"
        placeholder="Seçiniz."
        size="md"
        data={[
          { value: "paid", label: "Ücretli" },
          { value: "unpaid", label: "Ücretsiz" },
        ]}
        {...form.getInputProps("type")}
      />
      <Textarea
        label="Notlar"
        placeholder="İzin için not girebilirsiniz."
        autosize
        minRows={3}
        maxRows={3}
        {...form.getInputProps("note")}
      />

      <Button
        type="submit"
        color="#5C26FF"
        radius={10}
        disabled={!form.isDirty() || isLoading}
      >
        {isLoading ? <Loader color="#5C26FF" size={24} /> : "Oluştur"}
      </Button>
    </form>
  );
};

export default WorkPermitCreateModal;
